import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface ScoreHistoryPoint {
  date: string
  score: number
}

interface ScoreHistoryChartProps {
  history: ScoreHistoryPoint[]
  competitorName: string
}

function formatDate(value: string): string {
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return value
  }
  return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export default function ScoreHistoryChart({ history, competitorName }: ScoreHistoryChartProps) {
  const points = history
    .slice(-30)
    .map((point) => ({
      date: formatDate(point.date),
      score: Math.max(0, Math.min(100, Number(point.score) || 0)),
    }))

  if (points.length === 0) {
    return (
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
        No score history available yet.
      </div>
    )
  }

  return (
    <div className="h-56 rounded-lg border border-slate-200 bg-white p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Score History (30d)</p>
      <div className="mt-2 h-44">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#64748b' }} minTickGap={20} />
            <YAxis domain={[0, 100]} tick={{ fontSize: 11, fill: '#64748b' }} width={34} />
            <Tooltip
              formatter={(value: number) => [Math.round(Number(value)), 'Threat Score']}
              labelFormatter={(label) => `${competitorName} • ${label}`}
            />
            <Line type="monotone" dataKey="score" stroke="#1e3a5f" strokeWidth={2.25} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
